<template>
  <b-modal
    :visible="showBasicDetailsJD"
    id="jd-detail"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    @hidden="hideBasicJobDetailsModal()"
  >
    <div>
      <div
        class="
          newpanlog-rs-mainhead
          pl-2
          pr-2
          pb-3
          d-flex
          align-items-center
          justify-content-between
        "
      >
        Job Details
      </div>
      <div
        class="rotate-on-hover xmark-pos"
        @click="hideBasicJobDetailsModal()"
      >
        <img src="../../../assets/panelist/blue_cross.svg" alt="" />
      </div>
      <hr class="hr-jd" />
      <div>
        <template>
          <div class="panlog-jobdeatils py-2 px-3 mb-2">
            <div>
              <div class="panlog-right-deatils-heading">Job Name</div>
              <div class="panlog-right-detail-subheads mt-7px">
                {{ panelJdDetails.title }}
              </div>
            </div>
            <div class="mt-3">
              <div class="panlog-right-deatils-heading">Job Type</div>
              <div class="panlog-right-detail-subheads mt-7px">
                {{ panelJdDetails.jobType }}
              </div>
            </div>
            <div class="mt-3">
              <div class="panlog-right-deatils-heading">Job Role</div>
              <div class="panlog-right-detail-subheads mt-7px">
                {{ panelJdDetails.role }}
              </div>
            </div>
            <div class="mt-3">
              <div class="panlog-right-deatils-heading">Job Description</div>
              <div
                class="panlog-right-detail-subheads mt-7px"
                v-html-safe="panelJdDetails.description"
              ></div>
            </div>
            <div class="mt-3">
              <div class="panlog-right-deatils-heading">Location</div>
              <div
                class="panlog-right-detail-subheads mt-7px"
                v-for="(location, index) in panelJdDetails.location"
                :key="index"
              >
                {{ location
                }}<span v-if="index < panelJdDetails.location.length - 1"
                  >,</span
                >
              </div>
            </div>
            <div class="mt-3">
              <div class="panlog-right-deatils-heading">
                Education Qualification
              </div>
              <div class="panlog-right-detail-subheads mt-7px">
                {{ panelJdDetails.educationQualification }}
              </div>
            </div>
            <div v-if="panelJdDetails.openingsCount" class="mt-3">
              <div class="panlog-right-deatils-heading">No. of Openings</div>
              <div class="panlog-right-detail-subheads mt-7px">
                {{ panelJdDetails.openingsCount }}
              </div>
            </div>
            <div v-else class="mt-3">
              <div class="panlog-right-deatils-heading">No. of Openings</div>
              <div class="panlog-right-detail-subheads mt-7px">-</div>
            </div>
            <div class="mt-3">
              <div class="panlog-right-deatils-heading">Skills</div>
              <div
                class="panlog-right-detail-subheads mt-7px"
                v-for="(skill, index) in panelJdDetails.skills"
                :key="index"
              >
                {{ skill
                }}<span v-if="index < panelJdDetails.skills.length - 1">,</span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: "JobDetails",
  data() {
    return {
      isLaptop: true,
    };
  },
  props: {
    panelJdDetails: Object,
    showBasicDetailsJD: Boolean,
  },
  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
  },
  methods: {
    checkScreenSize() {
      this.isLaptop = window.innerWidth >= 1024;
    },
    hideBasicJobDetailsModal() {
      this.$emit("hideBasicJobDetailsModal");
    },
  },
};
</script>
